<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/saxbG9/tc-custom/9780814791196.jpg?1705026825457" alt="This image is the cover for the book Dreaming in the World's Religions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dreaming in the World's Religions
      </h1>
      <p class="bookDescription body article font2">
        <p>From Biblical stories of Joseph interpreting Pharoh’s dreams in Egypt to prayers against bad dreams in the Hindu Rg Veda, cultures all over the world have seen their dreams first and foremost as religiously meaningful experiences. In this widely shared view, dreams are a powerful medium of transpersonal guidance offering the opportunity to communicate with sacred beings, gain valuable wisdom and power, heal suffering, and explore new realms of existence. Conversely, the world’s religious and spiritual traditions provide the best source of historical information about the broad patterns of human dream life<br/><b>Dreaming in the World’s Religions</b> provides an authoritative and engaging one-volume resource for the study of dreaming and religion. It tells the story of how dreaming has shaped the religious history of humankind, from the Upanishads of Hinduism to the Qur’an of Islam, from the conception dream of Buddhas mother to the sexually tempting nightmares of St. Augustine, from the Ojibwa vision quest to Australian Aboriginal journeys in the Dreamtime. Bringing his background in psychology to bear, Kelly Bulkeley incorporates an accessible consideration of cognitive neuroscience and evolutionary psychology into this fascinating overview.<br/><b>Dreaming in the World’s Religions</b> offers a carefully researched, accessibly written portrait of dreaming as a powerful, unpredictable, often iconoclastic force in human religious life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelly Bulkeley
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b3d30de